import { render, staticRenderFns } from "./UserCollections.vue?vue&type=template&id=26e616fa"
import script from "./UserCollections.vue?vue&type=script&lang=js"
export * from "./UserCollections.vue?vue&type=script&lang=js"
import style0 from "./UserCollections.vue?vue&type=style&index=0&id=26e616fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports